<template>
    <div id="unitCarousel" class="carousel slide" wrap="false" touch="false" data-bs-touch="false"
        data-bs-interval="false">
        <div class="carousel-inner">
            <div v-for="(contract, index) in contracts" :key="index" class="carousel-item"
                :class="{ active: index === currentIndex }">
                <div class="row">
                    <div class="col-xl-12 col-md-12">
                        <div class="card">
                            <div class="card-body" style="padding: 0px !important;">
                                <div id="v-pills-tabContent" class="tab-content ">
                                    <div id="enterprise"
                                        class="tab-pane fade show position-relative active enterprise-image"
                                        role="tabpanel" aria-labelledby="enterprise"
                                        :style="{ backgroundImage: 'url(' + contract.image_url + ')' }">
                                    </div>
                                </div>
                                <div class="row font-size">
                                    <div class="col-6 mt-4" style="text-align: left; padding-left: 35px;">
                                        <span class="segment-secondary-color font-size"
                                            style="opacity: 60%;">Empreendimento</span> <br>
                                        <span class="segment-primary-color">{{ contract.nome }}</span>
                                        <div class="row mt-2">
                                            <div class="col-12">
                                                <span class="segment-secondary-color font-size"
                                                    style="opacity: 60%;">Endereço</span> <br>
                                                <span class="segment-primary-color">{{ contract.endereco }}</span>
                                                <br>
                                            </div>
                                            <div class="row">
                                                <div class="col-12">
                                                    <span class="segment-primary-color d-inline">{{
                                                        contract.endereco_cidade }}- {{ contract.endereco_uf }}</span>
                                                    <a :href="contract.link_mapa" target="_blank"
                                                        class="p-2 mb-0 btn bg-segment-primary-color rounded-circle btn-map d-inline-flex justify-content-center align-items-center"
                                                        type="button"
                                                        style="width: 16px; height: 16px; margin-left: 5px;">
                                                        <i class="fa fa-map-marker white" style="font-size: 8px;"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>


                                        <div style="margin-top: 10px;">
                                            <span class="segment-secondary-color font-size"
                                                style="opacity: 60%;">Unidade</span><br>
                                            <span class="segment-primary-color">{{ contract.torre }} - {{
                                                contract.contrato_unidade }}<br></span>
                                        </div>
                                        <div class="mt-4" style="text-align: right; padding-right: 20px;">
                                        </div>
                                    </div>
                                    <div class="col-6 d-flex flex-column align-items-center mt-4">
                                        <building-progress-card :contract="contract" />
                                        <button type="button"
                                            class="btn custom-btn bg-segment-primary-color btn-sm mt-2"
                                            @click="toggleComponent('InfoBuilding')"> Detalhes da Obra</button>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div v-if="currentComponent == 'PrincipalCard'" class="mt-3 d-flex justify-content-center">
                            <div>
                                <button class="p-2 mb-0 btn bg-segment-primary-color rounded-circle custom-btn-carousel"
                                    type="button" :disabled="index == 0" data-bs-target="#unitCarousel"
                                    data-bs-slide="prev" data-bs-toggle="tooltip" data-bs-placement="top"
                                    title="Anterior" @click="saveContract(contracts[index - 1])">
                                    <i class="p-2 fa fa-angle-left white"></i>
                                </button>
                            </div>
                            <button class="p-2 mb-0 btn bg-segment-primary-color rounded-circle custom-btn-carousel"
                                type="button" :disabled="index + 1 == contracts.length" data-bs-target="#unitCarousel"
                                data-bs-slide="next" data-bs-toggle="tooltip" data-bs-placement="top" style=""
                                @click="saveContract(contracts[index + 1])">
                                <i class="p-2 fa fa-angle-right white"></i>
                            </button>
                        </div>
                        <div v-else class="mt-3 d-flex justify-content-center">
                            <button type="button" class="btn custom-btn bg-segment-primary-color"
                                @click="toggleComponent('PrincipalCard')">Mudar Empreendimento</button>
                        </div>
                    </div>
                </div>
                <hr class="my-5 horizontal dark" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import setNavPills from "@/assets/js/nav-pills.js";
import setTooltip from "@/assets/js/tooltip.js";
import BuildingProgressCard from "./BuildingProgressCard.vue";

const emit = defineEmits(["contracts"]);
const store = useStore();
const contracts = computed(() => store.getters.getAllContract);
const currentIndex = ref(0)
let currentComponent = computed(() => store.getters.getCurrentComponent);

onMounted(() => {
    setNavPills();
    setTooltip(store.state.bootstrap);
    findIndexOfMatchingObject();
});

const findIndexOfMatchingObject = () => {
    let currentContractString = localStorage.getItem('currentContract');
    let currentContract = null;

    if (currentContractString) {
        try {
            currentContract = JSON.parse(currentContractString);
        } catch (error) {
            currentContract = {};
        }
    } else {
        currentContract = {};
    }

    if (currentContract && currentContract.id_filial !== undefined && currentContract.id_empreendimento !== undefined) {
        currentIndex.value = (contracts.value ?? []).findIndex(item =>
            item &&
            item.id_filial === currentContract.id_filial &&
            item.id_empreendimento === currentContract.id_empreendimento
        ) ?? 0;
    } else {
        currentIndex.value = 0;
    }
}

const saveContract = (contract) => {
    store.commit('updateContract', contract);
    emit('contracts', contract);
}

const toggleComponent = (component) => {
    store.commit("updateComponent", component)
}
</script>


<style>
::-webkit-scrollbar {
    width: 6px;
}

::-webkit-scrollbar-track {
    background: transparent;
}

::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 3px;
}

::-webkit-scrollbar-thumb:hover {
    background-color: #555;
}

.white {
    color: white
}

.custom-btn-carousel {
    font-size: 30px !important;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 20px;
}

.btn-map {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex !important;
    justify-content: center;
    align-items: center;
}

.enterprise-image {
    background-size: cover;
    border-radius: 13px 13px 0 0;
    height: 204px;
}

.font-size {
    font-size: 0.875rem;
}

@media (min-width: 344px) and (max-width: 389px) {
    .enterprise-image {
        height: 164px !important;
    }
}

@media (min-width: 390px) and (max-width: 413px) {
    .enterprise-image {
        height: 192px !important;
    }
}

@media (min-width: 412px) and (max-width: 429px) {
    .enterprise-image {
        height: 216px !important;
    }
}

@media (min-width: 430px) {
    .enterprise-image {
        height: 220px !important;
    }
}

</style>